module.exports = __webpack_public_path__ + "img/1897.16b59fa2.gif";